"use strict";

var _Column;
import { MapMarkerIcon } from '@autoguru/icons';
import { Box, Column, Columns, Icon, Text } from '@autoguru/overdrive';
import clsx from 'clsx';
import { memo } from 'react';
import * as styles from './SuburbSelectOption.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SuburbSelectOption = /*#__PURE__*/memo(({
  className: _className = '',
  onGpsRequest,
  suggestion,
  highlighted
}) => {
  const optionSelected = () => typeof onGpsRequest === 'function' ? onGpsRequest() : () => void 0;
  return /*#__PURE__*/_jsx(Box, {
    as: "button"
    // biome-ignore lint/a11y/useSemanticElements: migration quick fix. To be fixed when code is touched
    ,
    role: "option",
    "aria-selected": highlighted,
    "aria-label": suggestion.text,
    className: clsx(_className, styles.root, {
      [styles.gpsBtn]: Boolean(onGpsRequest)
    }),
    backgroundColour: highlighted ? 'gray200' : 'white',
    paddingY: "3",
    paddingX: "4",
    display: "flex",
    width: "full",
    onMouseDown: e => e.preventDefault(),
    onClick: optionSelected,
    children: /*#__PURE__*/_jsxs(Columns, {
      noWrap: true,
      children: [_Column || (_Column = /*#__PURE__*/_jsx(Column, {
        paddingRight: "2",
        children: /*#__PURE__*/_jsx(Icon, {
          size: "medium",
          icon: MapMarkerIcon
        })
      })), /*#__PURE__*/_jsx(Column, {
        children: /*#__PURE__*/_jsx(Text, {
          align: "left",
          size: "4",
          className: clsx({
            [styles.gpsBtn]: Boolean(onGpsRequest)
          }),
          children: suggestion.text
        })
      })]
    })
  });
});